import { Controller } from "@hotwired/stimulus"

// Receipt CC list (Phelipe 2026-10-31): the Billing page's "Receipt emails"
// box and the "CC anyone else on receipts?" box after paying through an
// offer. Add posts the email, × removes it; the server answers with the whole
// list and the chips are redrawn in place (no reload), with a toast.
export default class extends Controller {
  static targets = ["list", "input", "error", "empty"]
  static values = { url: String, offer: String, emails: Array, removeLabel: String, errorText: String, chipClass: String }

  connect() {
    this._render()
  }

  async add(event) {
    event.preventDefault()
    const email = this.inputTarget.value.trim()
    if (!email) return
    if (await this._send("POST", email)) this.inputTarget.value = ""
  }

  async remove(event) {
    await this._send("DELETE", event.currentTarget.dataset.email)
  }

  async _send(method, email) {
    this.errorTarget.classList.add("hidden")
    try {
      const body = { email }
      if (this.offerValue) body.offer = this.offerValue
      const response = await fetch(this.urlValue, {
        method,
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": this._csrf() },
        body: JSON.stringify(body)
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(data.error || this.errorTextValue)
      this.emailsValue = data.emails || []
      this._render()
      if (data.message) this._showToast(data.message)
      return true
    } catch (error) {
      this.errorTarget.textContent = error.message
      this.errorTarget.classList.remove("hidden")
      return false
    }
  }

  _render() {
    const chips = this.emailsValue.map((email) => {
      const chip = document.createElement("li")
      chip.className = this.chipClassValue
      const label = document.createElement("span")
      label.textContent = email
      const remove = document.createElement("button")
      remove.type = "button"
      remove.className = "inline-flex h-8 w-8 items-center justify-center rounded-full opacity-70 hover:opacity-100"
      remove.dataset.email = email
      remove.dataset.action = "receipt-cc#remove"
      remove.setAttribute("aria-label", this.removeLabelValue.replace("%{email}", email))
      remove.textContent = "×"
      chip.append(label, remove)
      return chip
    })
    this.listTarget.replaceChildren(...chips)
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", this.emailsValue.length > 0)
  }

  _csrf() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  _showToast(message) {
    const el = document.createElement("div")
    el.className = "flash-toast-notice"
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    const msg = document.createElement("p")
    msg.className = "flex-1 text-sm"
    msg.textContent = message
    el.appendChild(msg)
    document.body.prepend(el)
  }
}
